import { on, reducer } from "ts-action";

import { loadBvBeschluesse, loadBvSitze, loadBvSitzungen } from "./bv-actions.js";
import type { BvSitze } from "../service/bv-service.js";
import type { GremiumDrucksachen, Sitzungen } from "../../gremien/service/gremien-service.js";

export interface BvState {
  sitzungen?: Sitzungen;
  beschluesse?: GremiumDrucksachen;
  sitze?: BvSitze;
}

const initialState: BvState = {};

/** Nur ablegen — beide Ergebnisse tragen mit, für welches Gremium sie gelten. */
export const bvReducer = reducer<BvState>(
  initialState,
  on(loadBvSitzungen.success, (state, { payload }) => ({ ...state, sitzungen: payload })),
  on(loadBvBeschluesse.success, (state, { payload }) => ({ ...state, beschluesse: payload })),
  on(loadBvSitze.success, (state, { payload }) => ({ ...state, sitze: payload })),
);
